import client from './api-client';

export const getConfiguracionForm87 = async(query) => {
    try {
        
        const response = await client.get(`cfg-forms?q=${query}`);
        if (response.status === 200 && response.data.code === 1) {
            return {
                cfg_form87: response.data.object
            }
        } else {
            throw new Error(response.data.message);
        }

    } catch(error){
        throw error;
    }
}
export const getFechas = async(query) => {
    try {
        
        const response = await client.get(`parametros?q=${query}`);
        if (response.status === 200 && response.data.code === 1) {
            return {
                fechas: response.data.object
            }
        } else {
            throw new Error(response.data.message);
        }

    } catch(error){
        throw error;
    }
}
export const getComboTipoFecha= async(query) => {
    try {
        
        const response = await client.get(`detalles?q=${query}`);
        if (response.status === 200 && response.data.code === 1) {
            return {
                comboTipoFecha: response.data.object
            }
        } else {
            throw new Error(response.data.message);
        }

    } catch(error){
        throw error;
    }
}
export const getCasos= async(query) => {
    try {
        
        const response = await client.get(`pago-cuotas/casos?q=${query}`);
        if (response.status === 200 && response.data.code === 1) {
            return {
                casosIngresoRecuperosCuota: response.data.object,
                query:query
            }
        } else {
            throw new Error(response.data.message);
        }

    } catch(error){
        throw error;
    }
}
export const getExcel= async(query) => {
    try {
        
        const response = await client.get(`pago-cuotas/xlsx?q=${query}`);
        if (response.status === 200 && response.data.code === 1) {
            return response.data.file
               
            
        } else {
            throw new Error(response.data.message);
        }

    } catch(error){
        throw error;
    }
}